// remainingCreditBalance
const INITIAL_STATE = {
  errors: {},
  data: {}
}
  
const remainingCreditBalance = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'REFUND_REMAINING_BALANCE_SUCCESS':
	  return { ...state, ...INITIAL_STATE, data: action.data }
  case 'REFUND_REMAINING_BALANCE_FAILED':
	  return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
	  return { ...state }
  }
};
  
export default remainingCreditBalance;
  